/**
 * @generated SignedSource<<8989ab44f0c4f076a587824a5a047c88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuditionTextElement_screener$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ElementBase_screener">;
  readonly " $fragmentType": "AuditionTextElement_screener";
};
export type AuditionTextElement_screener$key = {
  readonly " $data"?: AuditionTextElement_screener$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuditionTextElement_screener">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuditionTextElement_screener",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ElementBase_screener"
    }
  ],
  "type": "ScreenerNode",
  "abstractKey": null
};

(node as any).hash = "f6f24f391dc5b509c115a97ec118055a";

export default node;
